(function ($) {
    $.fn.changeDateColor = function () {
        var $self = $(this);
        var dateMatch = $self.text();
        var dateNow = new Date();
        var yearNow = dateNow.getFullYear();
        var monthNow = dateNow.getMonth();
        var dayNow = dateNow.getDate();
        var monthArr = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

        /**
        *инициализация
         */
        var init = function () {
            parseDate();
        };

        /**
         *распарсить дату из строки
         */
        var parseDate = function () {
            var day = parseInt(dateMatch);
            if (isNaN(day)) {
                return;
            }
            var wordsArray = dateMatch.slice(0, dateMatch.indexOf(',')).split(' ');
            var finalArr = wordsArray.map(function(word) {
                return word.replace(",","");
            });
            var month = finalArr[1];
            var year = parseInt(finalArr[2]);
            comparisonDate(day, month, year);
        };

        /**
         *сравниваем с текущий датой
         */
        var comparisonDate = function (day, month, year) {
            if(!isNaN(year) && year > yearNow) {
                return;
            }
            if (!isNaN(year) && year < yearNow) {
                colorChange();
                return;
            }
            if (monthArr.indexOf(month) > monthNow) {
                return;
            }
            if (monthArr.indexOf(month) < monthNow) {
                colorChange();
                return;
            }
            if (day < dayNow) {
                colorChange();
            }
        };

        /**
         *перекрашиваем прошедшую дату
         */
        var colorChange = function () {
            $self.addClass('gray');
        }

        init();
    };
    $('.js-color-date').each(function() {
        $(this).data('changeDateColor', $(this).changeDateColor());
    });
})(jQuery);
